import React, { useEffect, useState } from "react";
import { FaAlignJustify } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import { Collapse, Container, DropdownMenu, DropdownToggle, NavItem, Navbar, NavbarBrand, NavbarToggler, UncontrolledDropdown } from "reactstrap";
import { blogItems, otherPagesItems } from "../Data/Navbar/navbar";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const toggle = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 60) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <Navbar className={`navbar-expand-lg theme-nav fixed-top ${isScrolled ? "darkHeader" : ""}`}>
      <Container className='d-lg-flex align-items-center'>
        <div className="d-flex align-items-centers justify-content-between">
          <NavbarBrand href={`${process.env.PUBLIC_URL}/`}>
            <img src='assets/images/logo.png' alt='logo' />
          </NavbarBrand>
          <NavbarToggler type='button' onClick={toggle}>
            <span className='navbar-toggler-icon'>
              <FaAlignJustify/>
            </span>
          </NavbarToggler>
        </div>
        <Collapse className='navbar-collapse justify-content-end' id='mainmenu' isOpen={isOpen}>
          <ul className='navbar-nav ml-auto' id='mymenu'>
            <NavItem>
              <ScrollLink className='nav-link' activeClass='active' to='home' spy={true} smooth={true} offset={-70} duration={300}>
                Home
              </ScrollLink>
            </NavItem>
            <NavItem>
              <ScrollLink className='nav-link' activeClass='active' to='about' spy={true} smooth={true} offset={-70} duration={300}>
                about
              </ScrollLink>
            </NavItem>
            <NavItem>
              <ScrollLink className='nav-link' activeClass='active' to='feature' spy={true} smooth={true} offset={-70} duration={300}>
                feature
              </ScrollLink>
            </NavItem>
            <NavItem>
              <ScrollLink className='nav-link' activeClass='active' to='screenshots' spy={true} smooth={true} offset={-70} duration={300}>
                screenshot
              </ScrollLink>
            </NavItem>
            <NavItem>
              <ScrollLink className='nav-link' activeClass='active' to='team' spy={true} smooth={true} offset={-70} duration={300}>
                team
              </ScrollLink>
            </NavItem>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
              Blog
              </DropdownToggle>
              <DropdownMenu end>
                {blogItems.map((item, i) => {
                  return (
                    <NavItem key={i}>
                      <Link className='nav-link' to={item.link}>
                        {item.label}
                      </Link>
                    </NavItem>
                  );
                })}
              </DropdownMenu>
            </UncontrolledDropdown>
            <NavItem>
              <ScrollLink className='nav-link' activeClass='active' to='contact' spy={true} smooth={true} offset={-70} duration={300}>
                contact us
              </ScrollLink>
            </NavItem>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Other Page
              </DropdownToggle>
              <DropdownMenu end>
                {otherPagesItems.map((item, i) => {
                  return (
                    <NavItem key={i}>
                      <Link className='nav-link' to={item.link}>
                        {item.label}
                      </Link>
                    </NavItem>
                  );
                })}
              </DropdownMenu>
            </UncontrolledDropdown>
          </ul>
        </Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
